import axios from 'axios';

const baseUrl = process.env.REACT_APP_URL_METIOR;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const Designs = {

  /**
   * A partir de las siguientes funciones obtenemos los datos de la calculadora.
   */
  createDesign: (data, userId) => {
    const response = axios({
      url: `${baseUrl}/api/designs/${userId}?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  getDesignsByUser: (userId) => {
    const response = axios({
      url: `${baseUrl}/api/designs/${userId}?code=${apiCode}`,
      method: 'GET',
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

};

export default Designs;
